module.exports = __webpack_public_path__ + "img/bg-hero-tax-accountants-v2-m.4fc2b8d.png";